import superagent from 'superagent'

const email = {
  invite: (props) => {
    const { email, token } = props
    return new Promise((resolve, reject) => {
      superagent
        .post(`${__API_URI__}/Email/SendInvite?ccUser=true`)
        .set('Authorization', `Bearer ${token}`)
        .set('Content-Type', 'application/json')
        .set('Platform', 'Web')
        .set('Version', `${__version__}`)
        .send([email])
        .end((err, res) => {
          if (err) {
            console.error('Email sendInvite failed', err)
            return reject(err)
          }
          resolve(res.body)
        })
    })
  }
}

export default email